export enum ButtonTypes {
  Blue = 'blue',
  LightBlue = 'light-blue',
  Gray = 'gray',
  Beige = 'beige',
  White = 'white',
  Green = 'green',
}
